import React, { useState, useEffect, useRef, useCallback } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  TextField,
  Box,
  Typography,
  Avatar,
  IconButton,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Divider,
} from "@material-ui/core";
import {
  NavigateBefore,
  NavigateNext,
  Description as DocumentIcon,
  LocationOn as LocationIcon,
} from "@material-ui/icons";
import HttpService from "../services/httpService";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
const useStyles = makeStyles((theme) => ({
  root: {
    height: "calc(100vh - 100px)",
    display: "flex",
    flexDirection: "column",
  },
  chatContainer: {
    flex: 1,
    overflowY: "auto",
    padding: theme.spacing(2),
    backgroundColor: "#e5ddd5",
  },
  messageContainer: {
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "flex-start",
  },
  receivedMessage: {
    backgroundColor: "#fff",
    borderRadius: "0 8px 8px 8px",
    padding: theme.spacing(1),
    maxWidth: "70%",
    marginLeft: theme.spacing(1),
    boxShadow: "0 1px 1px rgba(0,0,0,0.1)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
  messageHeader: {
    display: "flex",
    marginBottom: theme.spacing(0.5),
  },
  timestamp: {
    fontSize: "0.75rem",
    color: "#667781",
    marginTop: theme.spacing(0.5),
    alignSelf: "flex-end",
  },
  userName: {
    fontWeight: "bold",
    color: "#075E54",
  },
  messageBody: {
    wordBreak: "break-word",
  },
  image: {
    width: "300px",
    height: "300px",
    borderRadius: "4px",
    cursor: "pointer",
    display: "block",
    margin: "8px 0",
    objectFit: "cover",
  },
  mediaContainer: {
    width: "300px",
    height: "300px",
    borderRadius: "4px",
    cursor: "pointer",
    display: "block",
    margin: "8px 0",
    overflow: "hidden",
  },
  video: {
    width: "100%",
    height: "100%",
    borderRadius: "4px",
    objectFit: "cover",
  },
  paginationContainer: {
    padding: theme.spacing(1),
    backgroundColor: "#f0f2f5",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    borderBottom: "1px solid #e0e0e0",
  },
  container: {
    display: "flex",
    height: "calc(100vh - 100px)",
  },
  sidebar: {
    width: "300px",
    borderRight: "1px solid #e0e0e0",
    backgroundColor: "#fff",
    overflowY: "auto",
  },
  chatList: {
    padding: 0,
  },
  chatItem: {
    padding: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    cursor: "pointer",
  },
  selectedChat: {
    backgroundColor: "#e8f5fe",
    "&:hover": {
      backgroundColor: "#e8f5fe",
    },
  },
  mainContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  loadMoreButton: {
    margin: theme.spacing(1),
    alignSelf: "center",
  },
  audio: {
    width: "100%",
    borderRadius: "4px",
  },
  document: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1),
    backgroundColor: "#f0f2f5",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#e8e8e8",
    },
  },
  documentIcon: {
    marginRight: theme.spacing(1),
    color: "#34B7F1",
  },
  location: {
    width: "100%",
    height: "200px",
    borderRadius: "4px",
    cursor: "pointer",
  },
  searchContainer: {
    padding: theme.spacing(1),
    backgroundColor: "#f0f2f5",
    borderBottom: "1px solid #e0e0e0",
  },
  searchForm: {
    display: "flex",
    gap: theme.spacing(1),
  },
}));
const IncomingWhatsAppMessages = (props) => {
  const [messages, setMessages] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerPage, setCustomerPage] = useState(1);
  const [customersLoading, setCustomersLoading] = useState(false);
  const [hasMoreCustomers, setHasMoreCustomers] = useState(true);
  const customerListRef = useRef(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [searchNumber, setSearchNumber] = useState("");
  const classes = useStyles();
  const renderMessage = (message) => {
    const formatMessageTime = (timestamp) => {
      const messageDate = moment(timestamp);
      const today = moment().startOf("day");
      const yesterday = moment().subtract(1, "days").startOf("day");
      if (messageDate.isSame(today, "day")) {
        return `Today at ${messageDate.format("hh:mm A")}`;
      } else if (messageDate.isSame(yesterday, "day")) {
        return `Yesterday at ${messageDate.format("hh:mm A")}`;
      } else {
        return messageDate.format("DD/MM/YYYY hh:mm A");
      }
    };
    const renderMediaContent = () => {
      switch (message.type) {
        case "text":
          return <Typography>{message.body}</Typography>;
        case "image":
          return (
            <img
              src={message?.mediaDetails?.url}
              alt="Shared image"
              className={classes.image}
              onClick={() => window.open(message?.mediaDetails?.url, "_blank")}
            />
          );
        case "video":
          return (
            <div className={classes.mediaContainer}>
              <video
                className={classes.video}
                controls
                onClick={(e) => e.stopPropagation()}
              >
                <source
                  src={message?.mediaDetails?.url}
                  type={message?.mediaDetails?.mimeType}
                />
                Your browser does not support the video element.
              </video>
            </div>
          );
        case "audio":
          return (
            <div className={classes.audio}>
              <audio
                className={classes.audio}
                controls
                onClick={(e) => e.stopPropagation()}
              >
                <source
                  src={message?.mediaDetails?.url}
                  type={message?.mediaDetails?.mimeType}
                />
                Your browser does not support the audio element.
              </audio>
            </div>
          );
        case "document":
          return (
            <div
              className={classes.document}
              onClick={() => window.open(message?.mediaDetails?.url, "_blank")}
            >
              <DocumentIcon className={classes.documentIcon} />
              <Typography>
                {message?.mediaDetails?.filename || "Document"}
              </Typography>
            </div>
          );
        case "location":
          const { latitude, longitude } = message.mediaDetails;
          const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
          return (
            <div
              className={classes.location}
              onClick={() => window.open(mapUrl, "_blank")}
            >
              <div className={classes.location}>
                <LocationIcon className={classes.documentIcon} />
                <Typography>
                  Location: {latitude}, {longitude}
                </Typography>
              </div>
              <img
                src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=15&size=600x300&markers=color:red%7C${latitude},${longitude}&key=YOUR_GOOGLE_MAPS_API_KEY`}
                alt="Location"
                className={classes.location}
              />
            </div>
          );
        default:
          return (
            <Typography>Unsupported message type: {message.type}</Typography>
          );
      }
    };
    return (
      <div key={message._id} className={classes.messageContainer}>
        <Avatar>{message.userName[0]}</Avatar>
        <div className={classes.receivedMessage}>
          <div className={classes.messageHeader}>
            <Typography variant="subtitle2" className={classes.userName}>
              {message.userName}
              <Typography
                component="span"
                variant="caption"
                style={{ marginLeft: "8px", color: "#667781" }}
              >
                ({message.waId})
              </Typography>
            </Typography>
          </div>
          <div className={classes.messageBody}>{renderMediaContent()}</div>
          <div className={classes.timestamp}>
            {formatMessageTime(message.timestamp)}
          </div>
        </div>
      </div>
    );
  };
  const handleSearchCustomer = async (e) => {
    e.preventDefault();
    if (!searchNumber) return;
    try {
      setLoading(true);
      handleCustomerSearch(searchNumber);
    } catch (error) {
      console.error("Error searching customer:", error);
      props.setSnackInfo({
        open: true,
        message: "Error searching customer",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const fetchMessages = async (contact_no = null) => {
    setLoading(true);
    props.setLoading(true);
    try {
      contact_no = contact_no || searchNumber;
      const params = {
        page,
        rowsPerPage,
        ...(contact_no && { contact_no }),
      };
      const response = await HttpService.getIncomingWhatsAppMessages(params);
      setMessages(response?.data?.result?.messages);
      setTotalPages(response?.data?.result?.totalPages);
      if(searchNumber) {
        setCustomers(response?.data?.customerDetails)
      }
    } catch (error) {
      console.log("Error fetching messages:", error.message);
      console.error("Error fetching messages:", error.message);
    } finally {
      props.setLoading(false);
      setLoading(false);
    }
  };
  const fetchMessagesAgain = async () => {
    setLoading(true);
    props.setLoading(true);
    try {
      const params = {
        page,
        rowsPerPage
      };
      const response = await HttpService.getIncomingWhatsAppMessages(params);
      setMessages(response.data.result.messages);
      setTotalPages(response.data.result.totalPages);
    } catch (error) {
      console.log("Error fetching messages:", error.message);
      console.error("Error fetching messages:", error.message);
    } finally {
      props.setLoading(false);
      setLoading(false);
    }
  };
  const handleCustomerSelect = (customer) => {
    setSelectedCustomer(customer);
    setPage(1);
    // fetchMessages(searchNumber);
  };
  const handleCustomerSearch = (searchNumber) => {
    fetchMessages(searchNumber);
  };
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };
  const fetchCustomers = async (page = 1) => {
    try {
      const response = await HttpService.getUniqueCustomers({
        page,
        limit: 10,
      });
      if (page === 1) {
        setCustomers(response.data);
      } else {
        setCustomers((prev) => [...prev, ...response.data]);
      }
      setHasMoreCustomers(response?.data.length === 10);
      setCustomersLoading(false);
    } catch (error) {
      console.error("Error fetching customers:", error);
      setCustomersLoading(false);
    }
  };

  const handleSearchNumber = (value) => {
    setSearchNumber(value);
    if (value.length === 0) {
      fetchCustomers(1)
      fetchMessagesAgain()
    }
  }

  const handleCustomerScroll = useCallback(
    (e) => {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (scrollHeight - scrollTop <= clientHeight * 1.5) {
        if (!customersLoading && hasMoreCustomers) {
          setCustomerPage((prev) => prev + 1);
        }
      }
    },
    [customersLoading, hasMoreCustomers]
  );
  useEffect(() => {
    fetchCustomers();
  }, []);
  useEffect(() => {
    if (customerPage > 1) {
      fetchCustomers(customerPage);
    }
  }, [customerPage]);
  useEffect(() => {
    if (selectedCustomer) {
      fetchMessages(selectedCustomer.contact_no);
    } else {
      fetchMessages();
    }
  }, [page, rowsPerPage, selectedCustomer]);
  return (
    <div className={classes.container}>
      <div
        className={classes.sidebar}
        ref={customerListRef}
        onScroll={handleCustomerScroll}
      >
        <Box p={1} bgcolor="#f0f2f5">
          <form
            onSubmit={handleSearchCustomer}
            style={{ display: "flex", gap: "8px" }}
          >
            <TextField
              size="small"
              variant="outlined"
              placeholder="Search by number"
              value={searchNumber}
              onChange={(e) => handleSearchNumber(e.target.value)}
              InputProps={{
                type: "tel",
                pattern: "[0-9]*",
              }}
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              type="submit"
              size="small"
              disabled={!searchNumber || loading}
            >
              Search
            </Button>
          </form>
        </Box>
        <List className={classes.chatList}>
          {
            customers.length === 0 && !customersLoading && (
              <ListItem>
                <ListItemText primary="No customers found" />
              </ListItem>
            )
          }
          {customers.map((customer) => (
            <React.Fragment key={customer._id}>
              <ListItem
                className={`${classes.chatItem} ${
                  selectedCustomer?._id === customer._id
                    ? classes.selectedChat
                    : ""
                }`}
                onClick={() => handleCustomerSelect(customer)}
              >
                <ListItemAvatar>
                  <Avatar>{customer.name[0]}</Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={customer.name}
                  secondary={customer.contact_no}
                />
              </ListItem>
              <Divider />
            </React.Fragment>
          ))}
          {customersLoading && (
            <ListItem>
              <ListItemText
                primary={
                  <Typography align="center">
                    Loading more customers...
                  </Typography>
                }
              />
            </ListItem>
          )}
        </List>
      </div>
      <div className={classes.mainContent}>
        <Box className={classes.paginationContainer}>
          <IconButton
            onClick={() => handlePageChange(page - 1)}
            disabled={page === 1}
          >
            <NavigateBefore />
          </IconButton>
          <Typography variant="body2" style={{ margin: "0 16px" }}>
            Page {page} of {totalPages}
          </Typography>
          <IconButton
            onClick={() => handlePageChange(page + 1)}
            disabled={page === totalPages}
          >
            <NavigateNext />
          </IconButton>
          <TextField
            select
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            variant="outlined"
            size="small"
            style={{ width: 100, marginLeft: 16 }}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </TextField>
        </Box>
        <div className={classes.chatContainer}>
          {loading ? (
            <Box display="flex" justifyContent="center" p={3}>
              <Typography>Loading replies...</Typography>
            </Box>
          ) : messages.length > 0 ? (
            messages.map(renderMessage)
          ) : (
            <Box display="flex" justifyContent="center" p={3}>
              <Typography>
                {selectedCustomer
                  // ? `No messages found for ${selectedCustomer.name}`
                  ? `No messages found`
                  : "Select a customer to view messages"}
              </Typography>
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};
export default connect(null, { setLoading, setSnackInfo })(
  IncomingWhatsAppMessages
);